import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}

interface PostLoginBody {
  email: string;
  password: string;
}

export const CategoryApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategory: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        start?: number;
        length?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.getCategory}?start=${start}&length=${length}&search=${search}`,
        method: "GET",
      }),
    }),
    getSubCategory: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        start?: number;
        length?: number;
        id: number;
      }
    >({
      query: ({ length, search, start, id }) => ({
        url: `${END_POINTS.getSubCategory}${id}/?start=${start}&length=${length}&search=${search}`,
        method: "GET",
      }),
    }),
    getSubCategoryById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getSubCategoryById}/${id}/`,
        method: "GET",
      }),
    }),
    getCategoryById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getCategoryById}/${id}/`,
        method: "GET",
      }),
    }),
    addCategory: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addCategory,
        method: "POST",
        body,
      }),
    }),
    addSubCategory: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addSubCategory,
        method: "POST",
        body,
      }),
    }),
    updateCategory: builder.mutation<
      CommonResponseType,
      { body: any; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateCategory}?id=${id}`,
        method: "POST",
        body,
      }),
    }),
    updateSubCategory: builder.mutation<
      CommonResponseType,
      { body: any; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateSubCategory}?id=${id}`,
        method: "POST",
        body,
      }),
    }),

    deleteCategory: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteCategory}${id}/`,
        method: "DELETE",
      }),
    }),
    deleteSubCategory: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteSubCategory}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetCategoryQuery,
  useLazyGetCategoryByIdQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useAddSubCategoryMutation,
  useUpdateSubCategoryMutation,
  useDeleteSubCategoryMutation,
  useLazyGetSubCategoryQuery,
  useLazyGetSubCategoryByIdQuery,
} = CategoryApi;
